/**
 * Minimum properties associated with the `data-nav` property.
 */
export type StateWithDataNav = {
  root: {
    "data-nav"?: boolean;
  };
};

/**
 * Process the `state` as a mutable draft state and set the `data-nav` property according
 * to `valueOrDefaultValue`.
 */
export function useDataNav<T extends StateWithDataNav>(
  state: T,
  value?: boolean
) {
  if (value !== undefined) {
    state.root["data-nav"] = value;
  }
}
